export function Footer() {
  return (
    <footer className="py-10 border-t border-white/5 bg-[#050505]" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-500 text-sm">&copy; 2025 AfroSports</p>
          <div className="flex gap-6 text-gray-500 text-sm">
            <a href="/about" className="hover:text-white transition-colors">About</a>
            <a href="/terms" className="hover:text-white transition-colors">Terms</a>
            <a href="/privacy" className="hover:text-white transition-colors">Privacy</a>
            <a href="/contact" className="hover:text-white transition-colors">Contact</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
